
import MediaRoomsList from 'components/organisms/MediaRoomsList/MediaRoomsList';
import React from 'react';

 export default function MediaRooms () {
    return (
        <div>
            <MediaRoomsList />
        </div>
    );
}
